import { ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const ContentWrapper = styled.div<{
  $justify?: 'start' | undefined;
  $gap?: number | undefined;
}>`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: ${(props) => (props.$justify ? `start` : `center`)};
  align-items: center;
  gap: ${(props) => `${props.$gap?.toString() ?? '3'}vmin`};
`;

export const Content = ({
  gap,
  justify,
  children,
}: {
  gap?: number;
  justify?: 'start';
  children: ReactNode;
}) => {
  return (
    <Wrapper>
      <ContentWrapper $justify={justify} $gap={gap}>
        {children}
      </ContentWrapper>
    </Wrapper>
  );
};
